<template>
  <div class="content-body">
    <div class="top-font">数据看板</div>
    <div class="data-view">
      <div class="view-content">
        <div class="data-item">
          <div class="data-title">可用余额</div>
          <div class="data-value">￥{{ data.company_balance }}</div>
          <div class="data-trip">
            <div class="dw green">CNY</div>
            <div class="name">账户可用有效金额</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">今日花费</div>
          <div class="data-value">￥{{ data.today_pay }}</div>
          <div class="data-trip">
            <div class="dw green">CNY</div>
            <div class="name">今日投放支出金额</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">昨日花费</div>
          <div class="data-value">￥{{ data.yesterday_pay }}</div>
          <div class="data-trip">
            <div class="dw green">CNY</div>
            <div class="name">昨日投放花费</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">本月花费</div>
          <div class="data-value">￥{{ data.month_pay }}</div>
          <div class="data-trip">
            <div class="dw green">CNY</div>
            <div class="name">本月实际花费金额</div>
          </div>
        </div>
      </div>
      <div class="view-content">
        <div class="data-item">
          <div class="data-title">今日曝光</div>
          <div class="data-value" v-text="data.today_read"></div>
          <div class="data-trip">
            <div :class="'dw' + (data.read_percent > 0 ? ' red' : 'green')">{{ data.read_percent }}%</div>
            <div class="name">相比昨日投放展示量</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">今日点击</div>
          <div class="data-value" v-text="data.today_look"></div>
          <div class="data-trip">
            <div :class="'dw' + (data.look_percent > 0 ? ' red' : 'green')">{{ data.look_percent }}%</div>
            <div class="name">相比昨日广告投放点击量</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">今日点击率</div>
          <div class="data-value" v-text="data.today_click_l"></div>
          <div class="data-trip">
            <div :class="'dw' + (data.click_l_percent > 0 ? ' red' : 'green')">{{ data.click_l_percent }}%</div>
            <div class="name">相比昨日广告投放点击率</div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-title">本月曝光</div>
          <div class="data-value" v-text="data.month_read"></div>
          <div class="data-trip">
            <div :class="'dw' + (data.month_percent > 0 ? ' red' : 'green')">{{ data.month_percent }}%</div>
            <div class="name">相比昨日广告投放实时出价</div>
          </div>
        </div>
      </div>
    </div>
    <div class="schedule">
      <div class="left-content">
        <div class="s-header">
          <div class="left-title">投放费用</div>
          <div class="right-condition">
            <el-button type="primary" size="small" @click="jumpPlan">查看计划</el-button>
          </div>
        </div>
        <div class="schedule-content">
          <div id="myChart" :style="{width: '100%', height: '374px'}"></div>
        </div>
      </div>
      <div class="right-swiper">
        <el-carousel height="434px" indicator-position="none">
          <el-carousel-item v-for="(item, index) in data.banner" :key="index">
            <div class="img" @click="openWindow(item.link)">
              <el-image :src="item.pic_url" alt="" class="pic" fit="cover" />
              <div class="desc">
                <div class="desc-info">{{ item.name }}</div>
                <div class="time">{{ item.date }}</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="bottom-content">
      <div class="left-content">
        <div class="title">投放走势图</div>
        <div id="advUse" style="height: 274px; width: 100%;"></div>
      </div>
      <div class="right-content">
        <div class="title">物料概览</div>
        <div class="right-adv-body">
          <div class="adv-item">
            <div class="top-cont">
              <div class="name">WAP端物料</div>
              <div class="value" v-text="data.material.wap_num"></div>
            </div>
            <div class="process">
              <div class="select" :style="'width:' + data.material.wap_num + '%'"></div>
            </div>
          </div>
          <div class="adv-item">
            <div class="top-cont">
              <div class="name">PC端物料</div>
              <div class="value" v-text="data.material.pc_num"></div>
            </div>
            <div class="process">
              <div class="select" :style="'width:' + data.material.pc_num + '%'"></div>
            </div>
          </div>
          <div class="adv-item">
            <div class="top-cont">
              <div class="name">已通过</div>
              <div class="value" v-text="data.material.pass_num"></div>
            </div>
            <div class="process">
              <div class="select" :style="'width:' + data.material.pass_num + '%'"></div>
            </div>
          </div>
          <div class="adv-item">
            <div class="top-cont">
              <div class="name">审核中</div>
              <div class="value" v-text="data.material.wait_num"></div>
            </div>
            <div class="process">
              <div class="select" :style="'width:' + data.material.wait_num + '%'"></div>
            </div>
          </div>
          <div class="adv-item">
            <div class="top-cont">
              <div class="name">已驳回</div>
              <div class="value" v-text="data.material.fail_num"></div>
            </div>
            <div class="process">
              <div class="select" :style="'width:' + data.material.fail_num + '%'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import echarts from 'echarts';
export default {
  name: 'index',
  data() {
    return {
      form: {
        dateType: '1',
        type: ''
      },
      curentComponents: 'PlanView',
      tableData: [],
      dialogVisible: false,
      company_name: '',
      data: {
        today_pay: 0,
        yesterday_pay: 0,
        month_pay: 0,
        company_balance: 0,
        today_read: 0,
        today_look: 0,
        read_percent: 0,
        look_percent: 0,
        today_click_l: 0,
        click_l_percent: 0,
        month_read: 0,
        month_percent: 0,
        company_name: "",
        banner: 0,
        static: {
          data: [],
          value: [],
          read_value: [],
          look_value: [],
          click_l_value: [],
        },
        material: {
          wap_num: 0,
          pc_num: 0,
          pass_num: 0,
          wait_num: 0,
          fail_num: 0,
        },
      },
    };
  },
  mounted() {
    document.title = '首页';
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      if (res.code === 200) {
        this.data = res.data
        this.$function.hiddenLoading();
        this.company_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_name'] : '';
        this.setFree();
        this.setCharts();
      }
    });
  },
  methods: {
    setFree() {
      const option = {
        xAxis: {
          type: 'category',
          data: this.data.static.data
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          splitLine: {
            show: false,
          },
        },
        grid: {
          top: '8%',
          left: '5%',
          right: '5%',
          bottom: '6%'
        },
        tooltip: {
          show: true, // 显示提示框
          trigger: 'axis'
        },
        series: [{
          data: this.data.static.value,
          type: 'line',
          smooth: true,
          color: '#17A34A'
        }]
      };
      const echartsRecords = echarts.init(document.getElementById('myChart'), 'walden');
      echartsRecords.setOption(option);
    },
    setCharts() {
      const option2 = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['展示量', '点击量', '点击率']
        },
        grid: {
          left: '8%',
          right: '4%',
          bottom: '8%',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.static.data
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: '展示量',
            type: 'line',
            stack: 'Total',
            smooth: true,
            color: '#5156BE',
            data: this.data.static.read_value
          },
          {
            name: '点击量',
            type: 'line',
            stack: 'Total',
            smooth: true,
            color: '#2AB57D',
            data: this.data.static.look_value
          },
          {
            name: '点击率',
            type: 'line',
            stack: 'Total',
            smooth: true,
            data: this.data.static.click_l_value
          },
        ]
      };
      const echartsRecords2 = echarts.init(document.getElementById('advUse'), 'walden');
      echartsRecords2.setOption(option2);
    },
    openWindow(url) {
      window.open(url);
    },
    jumpPlan() {
      this.$emit('form_call_back', 'adv');
    },
  }
};
</script>
<style lang="less" scoped="">
  .content-body {
    height: calc(100% - 46px);
    width: calc(100% - 62px);
		padding: 20px;
    color: #A0A0A0;
    font-size: 13px;
    .top-font {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .data-view {
      margin-top: 20px;
      .view-content {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .data-item {
          width: calc(25% - 45px);
          padding: 15px;
          border: 1px solid #EDEDF2;
          border-radius: 20px;
          .data-value {
            margin: 10px 0;
            font-size: 18px;
            color: #333333;
            font-weight: bold;
          }
          .data-trip {
            display: flex;
            align-items: center;
            font-size: 12px;
            .dw {
              font-size: 10px;
              padding: 2px 5px;
              border-radius: 3px;
              margin-right: 10px;
            }
            .green {
              background-color: #CAECDE;
              color: #17A34A;
            }
            .red {
              background-color: #FED8D7;
              color: #FC8B81;
            }
          }
        }
      }
    }
    .schedule {
      display: flex;
      justify-content: space-between;
      .left-content {
        width: calc(55% - 30px);
        padding: 15px;
        border: 1px solid #EDEDF2;
        border-radius: 20px;
        .s-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-title {
            font-size: 15px;
            font-weight: bold;
            color: #333333;
          }
        }
        .schedule-content {
          display: flex;
          .money-content {
            width: 20%;
            display: flex;
            justify-content: center;
            align-items: center;
            .money-title {
              font-size: 14px;
            }
            .money-value {
              color: #333333;
              font-size: 18px;
              font-weight: bold;
              margin: 10px 0;
            }
          }
        }
      }
      .right-swiper {
        width: calc(45% - 20px);
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        .img {
          width: 100%;
          height: 100%;
          position: relative;
          cursor: pointer;
          border-radius: 0 0 20px 20px;
          overflow: hidden;
          .pic {
            width: 100%;
            height: 100%;
            border-radius: 20px;
          }
          .desc {
            width: 100%;
            padding: 15px;
            background-color: rgba(0, 0, 0, .5);
            position: absolute;
            left: 0;
            bottom: 0;
            .desc-info {
              font-size: 15px;
              font-weight: bold;
              color: #ffffff;
            }
            .time {
              margin-top: 10px;
            }
          }
        }
      }
    }
    .bottom-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .left-content {
        width: calc(65% - 30px);
        padding: 15px;
        border: 1px solid #EDEDF2;
        border-radius: 20px;
      }
      .right-content {
        width: calc(35% - 50px);
        padding: 15px;
        border: 1px solid #EDEDF2;
        border-radius: 20px;
        .right-adv-body {
          padding: 0 5px;
          margin-top: 40px;
          .adv-item {
            margin-bottom: 20px;
            .top-cont {
              display: flex;
              justify-content: space-between;
              align-items: center;
              color: #666666;
            }
            .process {
              width: 100%;
              height: 8px;
              border-radius: 12px;
              background-color: #F6F6F6;
              margin-top: 10px;
              position: relative;
              .select {
                width: 5%;
                height: 8px;
                background-color: #17A34A;
                border-radius: 12px;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
        }
      }
      .title {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
      }
    }
    .table {
      margin-top: 10px;
    }
	}


</style>
